import React from 'react';
import './SpriteEditorPage.css';

const SpriteEditorPage = () => {

  return (
    <div className="spriteeditor-page">
      <div className="container">
        
        {/* Hero Section */}
        <div className="spriteeditor-hero">
          <h1>Sprite Editor</h1>
          <div className="hero-visual">
            <div className="sprite-preview">
              <div className="sprite-grid">
                <div className="sprite-pixel"></div>
                <div className="sprite-pixel"></div>
                <div className="sprite-pixel"></div>
                <div className="sprite-pixel"></div>
                <div className="sprite-pixel"></div>
                <div className="sprite-pixel"></div>
                <div className="sprite-pixel"></div>
                <div className="sprite-pixel"></div>
                <div className="sprite-pixel"></div>
                <div className="sprite-pixel"></div>
                <div className="sprite-pixel"></div>
                <div className="sprite-pixel"></div>
                <div className="sprite-pixel"></div>
                <div className="sprite-pixel"></div>
                <div className="sprite-pixel"></div>
                <div className="sprite-pixel"></div>
              </div>
              <div className="editor-tools">
                <span>🖌️</span>
                <span>🎨</span>
                <span>🪞</span>
              </div>
            </div>
          </div>
        </div>

        {/* Project Overview */}
        <div className="project-section">
          <h2>About Sprite Editor</h2>
          <p>
            Sprite Editor is a comprehensive pixel art and animation tool developed as a 4-person group project 
            for CS3505 at the University of Utah. Built using C++ and Qt Creator, this application follows 
            agile development guidelines to deliver a professional sprite editing experience.
          </p>
          <p>
            The project demonstrates strong software engineering practices, including proper MVC architecture 
            and team coordination to create a cohesive application that seamlessly integrates all components.
          </p>
          <div className="demo-video">
            <video autoPlay loop muted playsInline>
              <source src="/projects/spriteeditor/mainoverviewvideo_spriteeditor.mp4" type="video/mp4" />
            </video>
          </div>
        </div>

        {/* Technology Stack */}
        <div className="tech-section">
          <h2>Technologies Used</h2>
          <div className="tech-grid">
            <div className="tech-item">
              <div className="tech-icon">⚙️</div>
              <span>C++</span>
            </div>
            <div className="tech-item">
              <div className="tech-icon">🖼️</div>
              <span>Qt Creator</span>
            </div>
            <div className="tech-item">
              <div className="tech-icon">📐</div>
              <span>Qt Framework</span>
            </div>
            <div className="tech-item">
              <div className="tech-icon">📋</div>
              <span>JSON</span>
            </div>
          </div>
        </div>

        {/* Key Features */}
        <div className="features-section">
          <h2>Key Features</h2>
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">🎨</div>
              <h3>Create Sprites</h3>
              <p>Intuitive interface for creating new sprites with pixel-level precision</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">🎬</div>
              <h3>Animation Support</h3>
              <p>Create and manage sprite animations with frame-by-frame editing</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">💾</div>
              <h3>Save & Load</h3>
              <p>Save and load animations in JSON format for easy sharing and storage</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">👁️</div>
              <h3>Onion Skin</h3>
              <p>View previous frames with onion skinning to maintain consistency in animations</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">🪞</div>
              <h3>Mirror Drawing</h3>
              <p>Symmetrical drawing tool with mirror functionality for creating balanced sprites</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">🖌️</div>
              <h3>Customizable Tools</h3>
              <p>Adjustable brush size and color picker for flexible sprite creation</p>
            </div>
          </div>
        </div>

        {/* Technical Challenges */}
        <div className="challenges-section">
          <h2>Technical Challenges</h2>
          <div className="challenge-list">
            <div className="challenge-item">
              <div className="challenge-number">01</div>
              <div className="challenge-content">
                <h3>Team Coordination</h3>
                <p>Coordinating all team members to create a project that flows together seamlessly, ensuring consistent code style and architecture across different components</p>
              </div>
            </div>
            <div className="challenge-item">
              <div className="challenge-number">02</div>
              <div className="challenge-content">
                <h3>Qt Signal-Slot Architecture</h3>
                <p>Implementing proper communication between the view and model using Qt's connect method, ensuring clean separation of concerns and maintainable code structure</p>
              </div>
            </div>
            <div className="challenge-item">
              <div className="challenge-number">03</div>
              <div className="challenge-content">
                <h3>Agile Development</h3>
                <p>Following agile guidelines while managing a 4-person team, ensuring regular iterations and continuous integration of features</p>
              </div>
            </div>
            <div className="challenge-item">
              <div className="challenge-number">04</div>
              <div className="challenge-content">
                <h3>JSON Serialization</h3>
                <p>Implementing robust save and load functionality using JSON format, ensuring data integrity and proper parsing of complex animation data</p>
              </div>
            </div>
          </div>
        </div>
        
      </div>
    </div>
  );
};

export default SpriteEditorPage;
